/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileGroupItemDto
 */
export interface FileGroupItemDto {
    /**
     * 
     * @type {string}
     * @memberof FileGroupItemDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof FileGroupItemDto
     */
    fileIdentifier?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileGroupItemDto
     */
    isCurrent: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileGroupItemDto
     */
    companyName?: string | null;
    /**
     * First beneficiary of the file; null for the file "for the company"
     * @type {string}
     * @memberof FileGroupItemDto
     */
    beneficiaryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileGroupItemDto
     */
    quoteId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileGroupItemDto
     */
    productLabel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileGroupItemDto
     */
    clientPrice?: number | null;
    /**
     * SIGNED, CONTRACT_SENT, MANDATE_SIGNED or TO_COMPLETE
     * @type {string}
     * @memberof FileGroupItemDto
     */
    status: string;
    /**
     * Number of not cancelled quotes of the file
     * @type {number}
     * @memberof FileGroupItemDto
     */
    quotesCount: number;
}

/**
 * Check if a given object implements the FileGroupItemDto interface.
 */
export function instanceOfFileGroupItemDto(value: object): value is FileGroupItemDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('isCurrent' in value) || value['isCurrent'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    return true;
}

export function FileGroupItemDtoFromJSON(json: any): FileGroupItemDto {
    return FileGroupItemDtoFromJSONTyped(json, false);
}

export function FileGroupItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileGroupItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'fileIdentifier': json['fileIdentifier'] == null ? undefined : json['fileIdentifier'],
        'isCurrent': json['isCurrent'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'beneficiaryName': json['beneficiaryName'] == null ? undefined : json['beneficiaryName'],
        'quoteId': json['quoteId'] == null ? undefined : json['quoteId'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'status': json['status'],
        'quotesCount': json['quotesCount'],
    };
}

export function FileGroupItemDtoToJSON(json: any): FileGroupItemDto {
    return FileGroupItemDtoToJSONTyped(json, false);
}

export function FileGroupItemDtoToJSONTyped(value?: FileGroupItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'fileIdentifier': value['fileIdentifier'],
        'isCurrent': value['isCurrent'],
        'companyName': value['companyName'],
        'beneficiaryName': value['beneficiaryName'],
        'quoteId': value['quoteId'],
        'productLabel': value['productLabel'],
        'clientPrice': value['clientPrice'],
        'status': value['status'],
        'quotesCount': value['quotesCount'],
    };
}

